import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import { PathTypeAccountInfo } from 'models/commonModel';
import { memo } from 'react';

interface Props {
    dataOption: { label: string; path: string }[];
    focus: string;
    onClickItem: (item: PathTypeAccountInfo) => void;
}

function HeaderAccount({ focus, onClickItem, dataOption }: Props) {
    return (
        <div className={styles.container}>
            {dataOption?.map((item, index) => (
                <div className={`${styles.item} ${focus === item.path ? 'active' : ''}`} onClick={() => onClickItem?.((item.path || '') as PathTypeAccountInfo)} key={index}>
                    <p>{item.label}</p>
                </div>
            ))}
        </div>
    );
}

export default memo(HeaderAccount);

const styles = {
    container: css`
        display: flex;
        gap: 6px;
        margin-bottom: 4px;
    `,
    item: css`
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 18px;
        padding-right: 18px;
        border-radius: 6px;
        border: 2px solid #ddca8c;
        cursor: pointer;
        background-color: ${colors.primary};

        p {
            color: #ddca8c;
            font-weight: 400;
        }

        &.active {
            background-color: white;
            border-bottom-color: transparent;
            margin-bottom: -7px;
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
            p {
                color: #023639;
                font-weight: 500;
                margin-top: 1px;
            }
        }
    `,
};
